import React from 'react'
import HandoverItemSection from './HandoverItemSection'

function HandoverRegisterExpandedRow({ data }) {
  const handoverRegisterId = data?.HandoverRegisterId
  const tabKey = handoverRegisterId || 'handover'

  return (
    <div className="p-3">
      <ul className="nav nav-pills justify-content-left nav-style-2 mb-3" role="tablist">
        <li key="Accessories" className="nav-item me-1" role="presentation">
          <a
            className="nav-link active"
            data-bs-toggle="tab"
            href={`#HandoverAccessories${tabKey}`}
            role="tab"
            aria-selected="true"
          >
            Handover Accessories
          </a>
        </li>
        <li key="Documents" className="nav-item" role="presentation">
          <a
            className="nav-link"
            data-bs-toggle="tab"
            href={`#HandoverDocuments${tabKey}`}
            role="tab"
            aria-selected="false"
          >
            Handover Documents
          </a>
        </li>
      </ul>

      <div className="tab-content">
        <div
          className="tab-pane fade active show"
          id={`HandoverAccessories${tabKey}`}
          role="tabpanel"
        >
          <HandoverItemSection
            handoverRegisterId={handoverRegisterId}
            itemType="Accessories"
            emptyLabel="No accessories configured."
          />
        </div>
        <div
          className="tab-pane fade"
          id={`HandoverDocuments${tabKey}`}
          role="tabpanel"
        >
          <HandoverItemSection
            handoverRegisterId={handoverRegisterId}
            itemType="Documents"
            emptyLabel="No documents configured."
          />
        </div>
      </div>
    </div>
  )
}

export default HandoverRegisterExpandedRow
